import appActionTypes from "../containers/App/store/constants";
import businessParterActionTypes from "../containers/BusinessPartnerDetails/store/constants";
import rejectedBusinessPartnerActionTypes from "../containers/RejectedBusinessPartners/store/constant";
import businessPartnerListActionTypes from "../containers/BusinessPartnerLists/store/constants";
import notificationActionTypes from "../containers/Notification/store/constants";
import ChangeLogActionTypes from "../containers/ChangeLog/store/constants";
import StewardBusinessPartnerListsTypes from "../containers/StewardBusinessPartnerLists/store/constant";

const ActionTypes = {
  ...appActionTypes,
  ...businessParterActionTypes,
  ...rejectedBusinessPartnerActionTypes,
  ...businessPartnerListActionTypes,
  ...notificationActionTypes,
  ...ChangeLogActionTypes,
  ...StewardBusinessPartnerListsTypes
};

export default ActionTypes;
